module.exports = __webpack_public_path__ + "static/media/icon-location.1691826f.svg";